// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
	height: 100%;
	margin: 0;
	padding: 0;
}

body {
  padding: 10px;
  font: 12px "Lucida Grande", Helvetica, Arial, sans-serif;
  -webkit-print-color-adjust: exact !important;
}

.page-content {
    position:absolute;
    top: 55px;
    left:10px;
    right:10px;
    bottom:20px;
    overflow-y:auto; 
}

.report-content {
    position:absolute;
    top: 50px;
    left:10px;
    right:10px;
    bottom:20px;
    overflow-y:auto; 
}

footer {
  position: fixed;
  bottom: 0px;
  left: 0px;
  overflow: hide;
  width: 100%;
  background: silver;
  padding : 5px; 
}

a {
  color: #00B7FF;
}

@grey:#2a2a2a;
@blue:#1fb5bf;
.login-panel {
  width: 40%;
  min-width: 320px;
  max-width: 475px;
  background: #fff;
  margin:15px auto;
  
  box-shadow: 0px 2px 5px rgba(0,0,0,.25);
  padding: 15px;
}


.pure-menu-heading {
    text-transform: none;
/*    color: #565d64; */
}

.navbar {
	background-color: #aed0f580;
	font-size: larger;
}	

.navbar-menu-list {
	float: right;
}

.modal-dialog.modal-wide {
	width: 800px;
	max-width: 800px;
}

.pageHeading {
  font-size: larger;
}

div.actionPanel {
  float: right;
  z-index: 100;
}

.actionPanel button.pure-button {
  margin: 5px;
  width: 125px;
  z-index: 100;
}

.report-table{
    border: 1px solid gray;
    table-layout: fixed;
    width: 100%;
}

.report-table th {
  font-size: larger;
  border-bottom: solid;
}


  div.textFrame {
    border-style: solid;
    border-width: 1px;  
    padding: 5px;
  }

  .barcodeCanvas {
    text-align: right;
  }

.job-report-branding {
  text-align: right;
}

.job-report-branding .job-report-branding-img {
  height: 50px;
}

ul.resource-location-list {
  list-style-type: none;
  columns: 4;
}

.tableFilter {
  margin-left: 5px;
}

table.job-heading-table td {
  padding-left : 5px;
}

  @media print {
    body * {
      margin-top: 5px;
      visibility: hidden;
    }

    .no-print {
      visibility: hidden;
    }
    .print * {
      visibility: visible;
    }

    .report-content {
      position:static;
      top: 20px;
      overflow-y:visible; 
    }

    ul.resource-location-list {
      columns: 2;
    }
  }

  @page {
    size: auto;
  }

  .modal-form {
    padding-left: 10px;
    padding-right: 10px;
  }

button.form-button {
  margin-top: 10px;
  float: right;
}  

.ui-widget-header {
  background-color: #aed0f580;
}

.fixed-height-modal {
  height: 100%;
}

.fixed-height-modal2 form {
  height: 95%;
}

.fixed-height-modal .tab-content {
  height: 93%;
}

.modalTab {
  height: 100%;
}

.modal-content {
  height: 95%;
}

.tabCtl {
   left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  position: relative;
  background: white;
  padding: 25px;
  padding-bottom: 80px;
  //width: 98%;
  //height: 250px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  border-radius: 5px;
  min-width: 240px; 
}

.tabs {
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  position: relative;
  background: white;
  padding: 10px;
  padding-bottom: 15px;
  //width: 98%;
  //height: 250px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  border-radius: 5px;
  min-width: 240px;
}

.tabs .content section h2, .tabs ul li label {
  font-weight: bold;
  font-size: 18px;
  color: #428BFF;
}

.tabs ul {
  list-style-type: none;
  padding-left: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  margin-bottom: 10px;
  -webkit-box-pack: justify;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: justify;
  justify-content: flex-start;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.tabs ul li {
  box-sizing: border-box;
  -webkit-box-flex: 0;
  -webkit-flex: 0;
  -ms-flex: 0;
  flex: 0;
  //width: 25%;
  padding: 0 10px;
  text-align: left;
}

.tabs ul li label {
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  color: #929daf;
  padding: 5px auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  white-space: nowrap;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.tabs ul li label br { display: none; }

.tabs ul li label svg {
  fill: #929daf;
  height: 1.2em;
  vertical-align: bottom;
  margin-right: 0.2em;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

.tabs ul li label:hover, .tabs ul li label:focus, .tabs ul li label:active {
  outline: 0;
  color: #bec5cf;
}

.tabs ul li label:hover svg, .tabs ul li label:focus svg, .tabs ul li label:active svg { fill: #bec5cf; }

.tabs .content { margin-top: 30px; }

.tabs .content section {
  display: none;
  -webkit-animation-name: content;
  animation-name: content;
  -webkit-animation-direction: normal;
  animation-direction: normal;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  line-height: 1.4;
}

.tabs .content section h2 {
  color: #428BFF;
  display: none;
}

.tabs .content section h2::after {
  content: "";
  position: relative;
  display: block;
  width: 30px;
  height: 3px;
  background: #428BFF;
  margin-top: 5px;
  left: 1px;
}

.tabs input[name="tab-control"]:nth-of-type(1):checked ~ ul > li:nth-child(1) > label {
  cursor: default;
  color: #428BFF;
}

.tabs input[name="tab-control"]:nth-of-type(1):checked ~ ul > li:nth-child(1) > label svg { fill: #428BFF; }
@media (max-width: 600px) {

.tabs input[name="tab-control"]:nth-of-type(1):checked ~ ul > li:nth-child(1) > label { background: rgba(0, 0, 0, 0.08); }
}

.tabs input[name="tab-control"]:nth-of-type(1):checked ~ .slider {
  -webkit-transform: translateX(0%);
  transform: translateX(0%);
}

.tabs input[name="tab-control"]:nth-of-type(1):checked ~ .content > section:nth-child(1) { display: block; }

.tabs input[name="tab-control"]:nth-of-type(2):checked ~ ul > li:nth-child(2) > label {
  cursor: default;
  color: #428BFF;
}

.tabs input[name="tab-control"]:nth-of-type(2):checked ~ ul > li:nth-child(2) > label svg { fill: #428BFF; }
@media (max-width: 600px) {

.tabs input[name="tab-control"]:nth-of-type(2):checked ~ ul > li:nth-child(2) > label { background: rgba(0, 0, 0, 0.08); }
}

.tabs input[name="tab-control"]:nth-of-type(2):checked ~ .slider {
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
}

.tabs input[name="tab-control"]:nth-of-type(2):checked ~ .content > section:nth-child(2) { display: block; }

.tabs input[name="tab-control"]:nth-of-type(3):checked ~ ul > li:nth-child(3) > label {
  cursor: default;
  color: #428BFF;
}

.tabs input[name="tab-control"]:nth-of-type(3):checked ~ ul > li:nth-child(3) > label svg { fill: #428BFF; }
@media (max-width: 600px) {

.tabs input[name="tab-control"]:nth-of-type(3):checked ~ ul > li:nth-child(3) > label { background: rgba(0, 0, 0, 0.08); }
}

.tabs input[name="tab-control"]:nth-of-type(3):checked ~ .slider {
  -webkit-transform: translateX(200%);
  transform: translateX(200%);
}

.tabs input[name="tab-control"]:nth-of-type(3):checked ~ .content > section:nth-child(3) { display: block; }

.tabs input[name="tab-control"]:nth-of-type(4):checked ~ ul > li:nth-child(4) > label {
  cursor: default;
  color: #428BFF;
}

.tabs input[name="tab-control"]:nth-of-type(4):checked ~ ul > li:nth-child(4) > label svg { fill: #428BFF; }
@media (max-width: 600px) {

.tabs input[name="tab-control"]:nth-of-type(4):checked ~ ul > li:nth-child(4) > label { background: rgba(0, 0, 0, 0.08); }
}

.tabs input[name="tab-control"]:nth-of-type(4):checked ~ .slider {
  -webkit-transform: translateX(300%);
  transform: translateX(300%);
}

.tabs input[name="tab-control"]:nth-of-type(4):checked ~ .content > section:nth-child(4) { display: block; }
@-webkit-keyframes 
content {  from {
 opacity: 0;
 -webkit-transform: translateY(5%);
 transform: translateY(5%);
}

to {
  opacity: 1;
  -webkit-transform: translateY(0%);
  transform: translateY(0%);
}
}
@keyframes 
content {  from {
 opacity: 0;
 -webkit-transform: translateY(5%);
 transform: translateY(5%);
}

to {
  opacity: 1;
  -webkit-transform: translateY(0%);
  transform: translateY(0%);
}
}
@media (max-width: 1000px) {

.tabs ul li label { white-space: initial; }

.tabs ul li label br { display: initial; }

.tabs ul li label svg { height: 1.5em; }
}
@media (max-width: 600px) {

.tabs ul li label {
  padding: 5px;
  border-radius: 5px;
}

.tabs ul li label span { display: none; }

.tabs .slider { display: none; }

.tabs .content { margin-top: 20px; }

.tabs .content section h2 { display: block; }
}

.assetMap {
  height: 600px;
  width: 100%;
}

.success {
  padding: 1em;
  margin-bottom: 0.75rem;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
  color: #468847;
  background-color: #dff0d8;
  border: 1px solid #d6e9c6;
  -webkit-border-radius: 4px;
     -moz-border-radius: 4px;
          border-radius: 4px;
}

.error {
  padding: 1em;
  margin-bottom: 0.75rem;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
  color: #b94a48;
  background-color: #f2dede;
  border: 1px solid rgba(185, 74, 72, 0.3);
  -webkit-border-radius: 4px;
     -moz-border-radius: 4px;
          border-radius: 4px;
}

td.header-table-value {
  font-weight: bolder;
}

td.header-table-label {
  font-size: smaller;
  font-weight: lighter;
}

.print-label {
  font-size: smaller;
  font-weight: lighter;
}

/* Chrome, Safari, Edge, Opera */
input.nospin::-webkit-outer-spin-button,
input.nospin::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input.nospin[type=number] {
    -moz-appearance: textfield;
}

tr.table-group-row td {
  text-align: left;
  
  background-color: #ebf0fa;
}

tr.table-footer-row th {
  background-color: #ebf0fa;
}`, "",{"version":3,"sources":["webpack://./client/javascript/common/style.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,SAAS;CACT,UAAU;AACX;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,4CAA4C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,SAAS;IACT,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,SAAS;IACT,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,aAAa;AACb,aAAa;AACb;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,uCAAuC;EACvC,aAAa;AACf;;;AAGA;IACI,oBAAoB;AACxB,uBAAuB;AACvB;;AAEA;CACC,2BAA2B;CAC3B,iBAAiB;AAClB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;;EAGE;IACE,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;AAEF;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;EAEE;IACE;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;IACA;MACE,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,SAAS;MACT,kBAAkB;IACpB;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;AAEF;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;GACG,SAAS;EACV,mCAAmC;EACnC,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,4EAA4E;EAC5E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,4EAA4E;EAC5E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;EACnC,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,OAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,gCAAgC;EAChC,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,uBAAuB,aAAa,EAAE;;AAEtC;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA,yFAAyF,aAAa,EAAE;;AAExG,iBAAiB,gBAAgB,EAAE;;AAEnC;EACE,aAAa;EACb,+BAA+B;EAC/B,uBAAuB;EACvB,mCAAmC;EACnC,2BAA2B;EAC3B,gCAAgC;EAChC,wBAAwB;EACxB,8CAA8C;EAC9C,sCAAsC;EACtC,oCAAoC;EACpC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,4FAA4F,aAAa,EAAE;AAC3G;;AAEA,wFAAwF,+BAA+B,EAAE;AACzH;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,2FAA2F,cAAc,EAAE;;AAE3G;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,4FAA4F,aAAa,EAAE;AAC3G;;AAEA,wFAAwF,+BAA+B,EAAE;AACzH;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,2FAA2F,cAAc,EAAE;;AAE3G;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,4FAA4F,aAAa,EAAE;AAC3G;;AAEA,wFAAwF,+BAA+B,EAAE;AACzH;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,2FAA2F,cAAc,EAAE;;AAE3G;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,4FAA4F,aAAa,EAAE;AAC3G;;AAEA,wFAAwF,+BAA+B,EAAE;AACzH;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,2FAA2F,cAAc,EAAE;AAC3G;WACW;CACV,UAAU;CACV,iCAAiC;CACjC,yBAAyB;AAC1B;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;AACA;WACW;CACV,UAAU;CACV,iCAAiC;CACjC,yBAAyB;AAC1B;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;AACA;;AAEA,oBAAoB,oBAAoB,EAAE;;AAE1C,uBAAuB,gBAAgB,EAAE;;AAEzC,wBAAwB,aAAa,EAAE;AACvC;AACA;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,yBAAyB,aAAa,EAAE;;AAExC,gBAAgB,aAAa,EAAE;;AAE/B,iBAAiB,gBAAgB,EAAE;;AAEnC,4BAA4B,cAAc,EAAE;AAC5C;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,6CAA6C;EAC7C,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;KACvB,uBAAuB;UAClB,kBAAkB;AAC5B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,6CAA6C;EAC7C,cAAc;EACd,yBAAyB;EACzB,wCAAwC;EACxC,0BAA0B;KACvB,uBAAuB;UAClB,kBAAkB;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA,YAAY;AACZ;IACI,0BAA0B;AAC9B;;AAEA;EACE,gBAAgB;;EAEhB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["html {\n\theight: 100%;\n\tmargin: 0;\n\tpadding: 0;\n}\n\nbody {\n  padding: 10px;\n  font: 12px \"Lucida Grande\", Helvetica, Arial, sans-serif;\n  -webkit-print-color-adjust: exact !important;\n}\n\n.page-content {\n    position:absolute;\n    top: 55px;\n    left:10px;\n    right:10px;\n    bottom:20px;\n    overflow-y:auto; \n}\n\n.report-content {\n    position:absolute;\n    top: 50px;\n    left:10px;\n    right:10px;\n    bottom:20px;\n    overflow-y:auto; \n}\n\nfooter {\n  position: fixed;\n  bottom: 0px;\n  left: 0px;\n  overflow: hide;\n  width: 100%;\n  background: silver;\n  padding : 5px; \n}\n\na {\n  color: #00B7FF;\n}\n\n@grey:#2a2a2a;\n@blue:#1fb5bf;\n.login-panel {\n  width: 40%;\n  min-width: 320px;\n  max-width: 475px;\n  background: #fff;\n  margin:15px auto;\n  \n  box-shadow: 0px 2px 5px rgba(0,0,0,.25);\n  padding: 15px;\n}\n\n\n.pure-menu-heading {\n    text-transform: none;\n/*    color: #565d64; */\n}\n\n.navbar {\n\tbackground-color: #aed0f580;\n\tfont-size: larger;\n}\t\n\n.navbar-menu-list {\n\tfloat: right;\n}\n\n.modal-dialog.modal-wide {\n\twidth: 800px;\n\tmax-width: 800px;\n}\n\n.pageHeading {\n  font-size: larger;\n}\n\ndiv.actionPanel {\n  float: right;\n  z-index: 100;\n}\n\n.actionPanel button.pure-button {\n  margin: 5px;\n  width: 125px;\n  z-index: 100;\n}\n\n.report-table{\n    border: 1px solid gray;\n    table-layout: fixed;\n    width: 100%;\n}\n\n.report-table th {\n  font-size: larger;\n  border-bottom: solid;\n}\n\n\n  div.textFrame {\n    border-style: solid;\n    border-width: 1px;  \n    padding: 5px;\n  }\n\n  .barcodeCanvas {\n    text-align: right;\n  }\n\n.job-report-branding {\n  text-align: right;\n}\n\n.job-report-branding .job-report-branding-img {\n  height: 50px;\n}\n\nul.resource-location-list {\n  list-style-type: none;\n  columns: 4;\n}\n\n.tableFilter {\n  margin-left: 5px;\n}\n\ntable.job-heading-table td {\n  padding-left : 5px;\n}\n\n  @media print {\n    body * {\n      margin-top: 5px;\n      visibility: hidden;\n    }\n\n    .no-print {\n      visibility: hidden;\n    }\n    .print * {\n      visibility: visible;\n    }\n\n    .report-content {\n      position:static;\n      top: 20px;\n      overflow-y:visible; \n    }\n\n    ul.resource-location-list {\n      columns: 2;\n    }\n  }\n\n  @page {\n    size: auto;\n  }\n\n  .modal-form {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\nbutton.form-button {\n  margin-top: 10px;\n  float: right;\n}  \n\n.ui-widget-header {\n  background-color: #aed0f580;\n}\n\n.fixed-height-modal {\n  height: 100%;\n}\n\n.fixed-height-modal2 form {\n  height: 95%;\n}\n\n.fixed-height-modal .tab-content {\n  height: 93%;\n}\n\n.modalTab {\n  height: 100%;\n}\n\n.modal-content {\n  height: 95%;\n}\n\n.tabCtl {\n   left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  position: relative;\n  background: white;\n  padding: 25px;\n  padding-bottom: 80px;\n  //width: 98%;\n  //height: 250px;\n  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);\n  border-radius: 5px;\n  min-width: 240px; \n}\n\n.tabs {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  position: relative;\n  background: white;\n  padding: 10px;\n  padding-bottom: 15px;\n  //width: 98%;\n  //height: 250px;\n  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);\n  border-radius: 5px;\n  min-width: 240px;\n}\n\n.tabs .content section h2, .tabs ul li label {\n  font-weight: bold;\n  font-size: 18px;\n  color: #428BFF;\n}\n\n.tabs ul {\n  list-style-type: none;\n  padding-left: 0;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  margin-bottom: 10px;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: justify;\n  justify-content: flex-start;\n  -webkit-box-align: end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.tabs ul li {\n  box-sizing: border-box;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0;\n  -ms-flex: 0;\n  flex: 0;\n  //width: 25%;\n  padding: 0 10px;\n  text-align: left;\n}\n\n.tabs ul li label {\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  color: #929daf;\n  padding: 5px auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n  cursor: pointer;\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  white-space: nowrap;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.tabs ul li label br { display: none; }\n\n.tabs ul li label svg {\n  fill: #929daf;\n  height: 1.2em;\n  vertical-align: bottom;\n  margin-right: 0.2em;\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n}\n\n.tabs ul li label:hover, .tabs ul li label:focus, .tabs ul li label:active {\n  outline: 0;\n  color: #bec5cf;\n}\n\n.tabs ul li label:hover svg, .tabs ul li label:focus svg, .tabs ul li label:active svg { fill: #bec5cf; }\n\n.tabs .content { margin-top: 30px; }\n\n.tabs .content section {\n  display: none;\n  -webkit-animation-name: content;\n  animation-name: content;\n  -webkit-animation-direction: normal;\n  animation-direction: normal;\n  -webkit-animation-duration: 0.3s;\n  animation-duration: 0.3s;\n  -webkit-animation-timing-function: ease-in-out;\n  animation-timing-function: ease-in-out;\n  -webkit-animation-iteration-count: 1;\n  animation-iteration-count: 1;\n  line-height: 1.4;\n}\n\n.tabs .content section h2 {\n  color: #428BFF;\n  display: none;\n}\n\n.tabs .content section h2::after {\n  content: \"\";\n  position: relative;\n  display: block;\n  width: 30px;\n  height: 3px;\n  background: #428BFF;\n  margin-top: 5px;\n  left: 1px;\n}\n\n.tabs input[name=\"tab-control\"]:nth-of-type(1):checked ~ ul > li:nth-child(1) > label {\n  cursor: default;\n  color: #428BFF;\n}\n\n.tabs input[name=\"tab-control\"]:nth-of-type(1):checked ~ ul > li:nth-child(1) > label svg { fill: #428BFF; }\n@media (max-width: 600px) {\n\n.tabs input[name=\"tab-control\"]:nth-of-type(1):checked ~ ul > li:nth-child(1) > label { background: rgba(0, 0, 0, 0.08); }\n}\n\n.tabs input[name=\"tab-control\"]:nth-of-type(1):checked ~ .slider {\n  -webkit-transform: translateX(0%);\n  transform: translateX(0%);\n}\n\n.tabs input[name=\"tab-control\"]:nth-of-type(1):checked ~ .content > section:nth-child(1) { display: block; }\n\n.tabs input[name=\"tab-control\"]:nth-of-type(2):checked ~ ul > li:nth-child(2) > label {\n  cursor: default;\n  color: #428BFF;\n}\n\n.tabs input[name=\"tab-control\"]:nth-of-type(2):checked ~ ul > li:nth-child(2) > label svg { fill: #428BFF; }\n@media (max-width: 600px) {\n\n.tabs input[name=\"tab-control\"]:nth-of-type(2):checked ~ ul > li:nth-child(2) > label { background: rgba(0, 0, 0, 0.08); }\n}\n\n.tabs input[name=\"tab-control\"]:nth-of-type(2):checked ~ .slider {\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%);\n}\n\n.tabs input[name=\"tab-control\"]:nth-of-type(2):checked ~ .content > section:nth-child(2) { display: block; }\n\n.tabs input[name=\"tab-control\"]:nth-of-type(3):checked ~ ul > li:nth-child(3) > label {\n  cursor: default;\n  color: #428BFF;\n}\n\n.tabs input[name=\"tab-control\"]:nth-of-type(3):checked ~ ul > li:nth-child(3) > label svg { fill: #428BFF; }\n@media (max-width: 600px) {\n\n.tabs input[name=\"tab-control\"]:nth-of-type(3):checked ~ ul > li:nth-child(3) > label { background: rgba(0, 0, 0, 0.08); }\n}\n\n.tabs input[name=\"tab-control\"]:nth-of-type(3):checked ~ .slider {\n  -webkit-transform: translateX(200%);\n  transform: translateX(200%);\n}\n\n.tabs input[name=\"tab-control\"]:nth-of-type(3):checked ~ .content > section:nth-child(3) { display: block; }\n\n.tabs input[name=\"tab-control\"]:nth-of-type(4):checked ~ ul > li:nth-child(4) > label {\n  cursor: default;\n  color: #428BFF;\n}\n\n.tabs input[name=\"tab-control\"]:nth-of-type(4):checked ~ ul > li:nth-child(4) > label svg { fill: #428BFF; }\n@media (max-width: 600px) {\n\n.tabs input[name=\"tab-control\"]:nth-of-type(4):checked ~ ul > li:nth-child(4) > label { background: rgba(0, 0, 0, 0.08); }\n}\n\n.tabs input[name=\"tab-control\"]:nth-of-type(4):checked ~ .slider {\n  -webkit-transform: translateX(300%);\n  transform: translateX(300%);\n}\n\n.tabs input[name=\"tab-control\"]:nth-of-type(4):checked ~ .content > section:nth-child(4) { display: block; }\n@-webkit-keyframes \ncontent {  from {\n opacity: 0;\n -webkit-transform: translateY(5%);\n transform: translateY(5%);\n}\n\nto {\n  opacity: 1;\n  -webkit-transform: translateY(0%);\n  transform: translateY(0%);\n}\n}\n@keyframes \ncontent {  from {\n opacity: 0;\n -webkit-transform: translateY(5%);\n transform: translateY(5%);\n}\n\nto {\n  opacity: 1;\n  -webkit-transform: translateY(0%);\n  transform: translateY(0%);\n}\n}\n@media (max-width: 1000px) {\n\n.tabs ul li label { white-space: initial; }\n\n.tabs ul li label br { display: initial; }\n\n.tabs ul li label svg { height: 1.5em; }\n}\n@media (max-width: 600px) {\n\n.tabs ul li label {\n  padding: 5px;\n  border-radius: 5px;\n}\n\n.tabs ul li label span { display: none; }\n\n.tabs .slider { display: none; }\n\n.tabs .content { margin-top: 20px; }\n\n.tabs .content section h2 { display: block; }\n}\n\n.assetMap {\n  height: 600px;\n  width: 100%;\n}\n\n.success {\n  padding: 1em;\n  margin-bottom: 0.75rem;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);\n  color: #468847;\n  background-color: #dff0d8;\n  border: 1px solid #d6e9c6;\n  -webkit-border-radius: 4px;\n     -moz-border-radius: 4px;\n          border-radius: 4px;\n}\n\n.error {\n  padding: 1em;\n  margin-bottom: 0.75rem;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);\n  color: #b94a48;\n  background-color: #f2dede;\n  border: 1px solid rgba(185, 74, 72, 0.3);\n  -webkit-border-radius: 4px;\n     -moz-border-radius: 4px;\n          border-radius: 4px;\n}\n\ntd.header-table-value {\n  font-weight: bolder;\n}\n\ntd.header-table-label {\n  font-size: smaller;\n  font-weight: lighter;\n}\n\n.print-label {\n  font-size: smaller;\n  font-weight: lighter;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput.nospin::-webkit-outer-spin-button,\ninput.nospin::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Firefox */\ninput.nospin[type=number] {\n    -moz-appearance: textfield;\n}\n\ntr.table-group-row td {\n  text-align: left;\n  \n  background-color: #ebf0fa;\n}\n\ntr.table-footer-row th {\n  background-color: #ebf0fa;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
